import React, { Fragment, useEffect, useState, useRef, useLayoutEffect } from 'react'
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import clsx from 'clsx';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
// import { Loader } from 'rsuite';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'react-bootstrap';
import EmployeeTaskList from './employeeTasks/EmployeeTaskList';
import EmployeeProjectList from './employeeProjects/EmployeeProjectList';
import EmployeeTimeOffList from './employeeTimeOffs/EmployeeTimeOffList';
import EmployeeEmailNotificationPreferences from './employeeEmailPreferences/EmployeeEmailNotificationPreferences';
import fetchAPI from '../../../common/fetchAPI';
import { getParentChildPagePermissionsAsync } from '../../../common/GlobalSlice';
import {
    updateAccountEmployeeId, updateIsReloadInState, updateIsLoading
    //updateAccountProjectId as getMethodFromProjectSlice, updateIsLoading, deleteAccountProject 
} from './employeeSlice';
import EmployeeOffCanvas from '../../../common/OffCanvas';
import EmployeeAddUpdate from './EmployeeAddUpdate';
import Loader from '../../../common/Loader';
import EmployeeCostCenter from './employeeCostCenter/EmployeeCostCenter';
import { formatHoursOff, isTimeEntryHoursFormat, getValueFromResource, FormatInvoiceDecimalNumber } from '../../../common/timeLiveFunction';
import * as Sentry from '@sentry/react'

const initialValues = {
    totalHours: '',
    billableHours: '',
    nonBillableHours: '',
    employeeNameWithCode: '',
    accountName: '',
    eMailAddress: ''
}

const initialValuesForPermissions = {
    IsTask: false,
    IsProject: false,
    IsProjectEdit: false,
    IsTimeOff: false,
    IsTimeOffEdit: false,
    IsEmailPreference: false,
    permissionList: []
}

export const EmployeeSummary = () => {
    const dispatch = useAppDispatch();
    const [tab, setTab] = useState('ProjectList');
    /* const { state } = useLocation();
    
    const { AccountEmployeeId, IsSummaryFrom } = state.obj || {}; */
    const storedObjectData = localStorage.getItem('objEmployee');
    const objectData = storedObjectData ? JSON.parse(storedObjectData) : null;
    const { IsSummaryFrom } = objectData;
    const { AccountEmployeeId } = useParams();
    const Parent_SystemSecurityCategoryPageId: string = "4";
    // const locationData = useLocation();
    const [employeeSummary, setEmployeeSummary] = useState<any | ''>(initialValues);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { cultureInfoName, pageId, menuList, IsList, IsAdd, IsEdit, IsDelete, isLoading: isLoading_globalState, showCostCenterInTimesheetBy, timeEntryHoursFormatId, decimalFormat } = useAppSelector((state) => state.globalState);
    const [childs, setChilds] = useState(initialValuesForPermissions);
    const { isReload, isLoading } = useAppSelector((state) => state.employee);


    useEffect(() => {
        renderAccountEmployeeSummary();
    }, [decimalFormat, timeEntryHoursFormatId, AccountEmployeeId]);
    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (Parent_SystemSecurityCategoryPageId && Parent_SystemSecurityCategoryPageId !== '') {
                getPermissions(Parent_SystemSecurityCategoryPageId, "152,176,141,100")
            }
        }
        fetchPagePermissions();
    }, [dispatch]);

    const getPermissions = (SystemSecurityCategoryPageId: string, ChildSystemSecurityCategoryPageIds: string) => {
        dispatch(getParentChildPagePermissionsAsync({ SystemSecurityCategoryPageId: SystemSecurityCategoryPageId, ChildSystemSecurityCategoryPageIds: ChildSystemSecurityCategoryPageIds }))
            .unwrap()
            .then((originalPromiseResult) => {
                if (originalPromiseResult.ParentPermission) {
                    if (originalPromiseResult.ParentPermission.IsList && originalPromiseResult.ChildPermission) {
                        const childPermission: any = originalPromiseResult.ChildPermission;
                        const isProject = childPermission.filter((x: any) => x.Id === 152)[0].IsList;
                        const isProjectEdit = childPermission.filter((x: any) => x.Id === 152)[0].IsEdit;
                        const isTask = childPermission.filter((x: any) => x.Id === 176)[0].IsList;
                        const isTimeOff = childPermission.filter((x: any) => x.Id === 141)[0].IsList;
                        const isTimeOffEdit = childPermission.filter((x: any) => x.Id === 141)[0].IsEdit;
                        const isEmailPreference = childPermission.filter((x: any) => x.Id === 100)[0].IsList;
                        setChilds({
                            ...childs,
                            IsProject: isProject,
                            IsProjectEdit: isProjectEdit,
                            IsTask: isTask,
                            IsTimeOff: isTimeOff,
                            IsTimeOffEdit: isTimeOffEdit,
                            IsEmailPreference: isEmailPreference,
                            permissionList: originalPromiseResult.ChildPermission
                        });
                        if (isProject) {
                            setTab('ProjectList');
                        }
                        else if (isTask) {
                            setTab('TaskList');
                        }
                        else if (isTimeOff) {
                            setTab('TimeOffList');
                        }
                        else if (showCostCenterInTimesheetBy.toLowerCase() == "Employee".toLowerCase()) {
                            setTab('CostCenterList');
                        }
                        else {
                            setTab('EmailPreferenceList');
                        }
                        //  renderAccountEmployeeSummary();
                        if (IsSummaryFrom === 'View' && isProject) {
                            setTab('ProjectList');
                        } else if (IsSummaryFrom === 'Task') {
                            setTab('TaskList');
                        } else if (IsSummaryFrom === 'Project') {
                            setTab('ProjectList');
                        } else if (IsSummaryFrom === 'EmailPreference') {
                            setTab('EmailPreferenceList');
                        } else if (IsSummaryFrom === 'TimeOff') {
                            setTab('TimeOffList');
                        } else if (IsSummaryFrom === 'CostCenter') {
                            setTab('CostCenterList');
                        }
                    }
                    else {
                        navigate('../error/403');
                    }
                }
                else {
                    navigate('../error/403');
                }
            })
            .catch((rejectedValueOrSerializedError) => {
                 Sentry.captureException(rejectedValueOrSerializedError);
            })
    }

    const renderAccountEmployeeSummary = async () => {      
        const TimeEntryFormat = decimalFormat ? 'Decimal' : 'Time'
        try {
            const response = await fetchAPI(`api/V2/Employees/AccountEmployeeSummary/${AccountEmployeeId}/${TimeEntryFormat}`, 'Get', '', true);
            const json = await response.json();
            let totalHours = json["TimeEntryHours"][0];
            let employeeDetail = json["EmployeeDetail"][0];
            setEmployeeSummary({
                ...employeeSummary,
                totalHours: totalHours?.TotalHours != null ? (decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), totalHours.TotalHours, 2) : totalHours.ConvertTotalMinutes) : FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, 2),
                billableHours: totalHours?.ConvertBillableTotalMinutes != null ? (decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), totalHours.ConvertBillableTotalMinutes, 2) : totalHours.ConvertBillableTotalMinutes) : FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, 2),
                nonBillableHours: totalHours?.ConvertNonBillableTotalMinutes != null ? (decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), totalHours.ConvertNonBillableTotalMinutes, 2) : totalHours.ConvertNonBillableTotalMinutes) : FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, 2),
                employeeNameWithCode: employeeDetail.EmployeeNameWithCode,
                accountName: employeeDetail.AccountName,
                eMailAddress: employeeDetail.EMailAddress
            })
            dispatch(updateIsReloadInState(false));
        } catch (error) {
            dispatch(updateIsReloadInState(false));
             Sentry.captureException(error);
        }
    }

    const generalObject = {
        "name": getValueFromResource('Update Employee', dispatch, t),
        "width": "700px",
        "componentName": <EmployeeAddUpdate t={t} ></EmployeeAddUpdate>
    }

    const navigateToAudit = (AccountEmployeeId: any) => {
        const obj = {
            Id: AccountEmployeeId,
            TableName: 'AccountEmployee',
            Title: getValueFromResource("Employee Audit", dispatch, t)
        }
        // navigate('/accountaudit', { state: { obj } });
        navigate(`/accountaudit/${AccountEmployeeId}`, { state: { obj } })

    };
    const navigateToEmployeeTimeOffAudit = (obj: any) => {    
        // navigate('/employeetimeoffaudit', { state: { obj } });       
        navigate(`/employeetimeoffaudit/${AccountEmployeeId}`, { state: { obj } })

      };

    /*     if (!state) {
            return null;
        } */

    return (
        <>
            {( isLoading) && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white dropdown-zindex">
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t('Employee Detail')} */}
                        {getValueFromResource('Employee Detail',dispatch, t)}

                        </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="btn-group">
                            <button
                                type="button"
                                className="btn btn-secondary btn-bs-btn-font-weight btn-sm dropdown-toggle"
                                data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <i className="fa fa-cog mb-1 me-1"></i>
                                {/* {t('Options')} */}
                                {getValueFromResource('Options',dispatch, t)}
                                <i className=""></i>
                                <i className="fa fa-angle-down"></i>
                            </button>
                            <ul className="dropdown-menu menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-175px" role="menu">
                                <div className='menu-hover-bg-sec'>
                                    {IsEdit && <Dropdown.Item
                                        id="kt_OffCanvas"
                                        className="menu-item me-lg-0"
                                        onClick={() => {
                                            dispatch(updateAccountEmployeeId(AccountEmployeeId));
                                        }}
                                    >
                                        <span className="menu-icon custom-menu mb-2">
                                            <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                        </span>
                                        <span className="menu-title custom-menu-fontsize">
                                            {/* {`${t('Edit Employee')}`} */}
                                            {getValueFromResource('Edit Employee',dispatch, t)}

                                            </span>
                                    </Dropdown.Item>
                                    }
                                    <Dropdown.Item
                                        id="kt_OffCanvas"
                                        className="menu-item me-lg-0"
                                        onClick={() => {
                                            // navigate('/accountbillingrate', {
                                                navigate(`/accountbillingrate/${AccountEmployeeId}`, {
                                                state: {
                                                    "AccountEmployeeId": AccountEmployeeId,
                                                    "SystemBillingRateTypeId": 1

                                                }
                                            })
                                        }}
                                    >
                                        <span className="menu-icon custom-menu mb-2">
                                            <i className="bi bi-currency-exchange fs-6 iconColor">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                        </span>
                                        <span className="menu-title custom-menu-fontsize">
                                            {/* {`${t('Rate History')}`} */}
                                            {getValueFromResource('Rate History',dispatch, t)}

                                            </span>
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        id="kt_OffCanvas"
                                        className="menu-item me-lg-0"
                                        onClick={() => {
                                            navigateToEmployeeTimeOffAudit({
                                              AccountTimeOffTypeId: '00000000-0000-0000-0000-000000000000',
                                              AccountEmployeeId: AccountEmployeeId,
                                              TableName: 'AccountEmployeeTimeOffAudit',
                                              Title: getValueFromResource('Employee Time Off Audit', dispatch, t)
                                            });
                                        }}
                                        // onClick={() => {
                                        //     navigate('/accountbillingrate', {
                                        //         state: {
                                        //             "AccountEmployeeId": AccountEmployeeId,
                                        //             "SystemBillingRateTypeId": 1

                                        //         }
                                        //     })
                                        // }}
                                    >
                                        <span className="menu-icon custom-menu mb-2">
                                            <i className="bi bi-receipt fs-6 iconColor">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                        </span>
                                        <span className="menu-title custom-menu-fontsize">
                                            {/* {`${t('Time Off Audit')}`} */}
                                            {getValueFromResource('Time Off Audit',dispatch, t)}

                                            </span>
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        className="menu-item me-lg-0 "
                                        onClick={() => navigateToAudit(AccountEmployeeId)}
                                    >
                                        <span className="menu-icon custom-menu mb-2">
                                            <i className="bi bi-receipt fs-6 iconColor">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                        </span>
                                        <span className="menu-title custom-menu-fontsize">
                                            {/* {`${t('Employee Audit')}`} */}
                                            {getValueFromResource('Employee Audit',dispatch, t)}
                                            </span>
                                    </Dropdown.Item>
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-9'>
                        <div className='mt-4'>
                            <div className="d-flex flex-wrap fs-7  pe-2">
                                <a className="text-gray-500">
                                    {employeeSummary.accountName}
                                </a>

                            </div>
                            <div className="d-flex align-items-center mt-2 mb-2">
                                <a className="text-muted fw-bold me-2 fs-2">{employeeSummary.employeeNameWithCode}</a>
                            </div>
                            <div className="d-flex flex-wrap fs-7 mb-4 pe-2">
                                <a className="text-gray-500">
                                    <i className="bi bi-calendar fs-6 iconColor me-2"></i>
                                    {`${employeeSummary.eMailAddress}`}
                                </a>
                            </div>
                        </div>
                        <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap mt-6' role='tablist'>
                            {childs.IsProject && <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'ProjectList' })}
                                    onClick={() => setTab('ProjectList')}
                                    role='tab'
                                >
                                    {/* {t("Projects")} */}
                                    {getValueFromResource('Projects',dispatch, t)}

                                </a>
                            </li>}
                            {childs.IsTask && <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'TaskList' })}
                                    onClick={() => setTab('TaskList')}
                                    role='tab'
                                >
                                    {/* {t("Tasks")} */}
                                    {getValueFromResource('Tasks',dispatch, t)}

                                </a>
                            </li>}
                            {childs.IsTimeOff && <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'TimeOffList' })}
                                    onClick={() => setTab('TimeOffList')}
                                    role='tab'
                                >
                                    {/* {t("TimeOff")} */}
                                    {getValueFromResource('Time Off',dispatch, t)}

                                </a>
                            </li>}
                            <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'EmailPreferenceList' })}
                                    onClick={() => setTab('EmailPreferenceList')}
                                    role='tab'
                                >
                                    {/* {t("Email Preference")} */}
                                    {getValueFromResource('Email Preference',dispatch, t)}

                                </a>
                            </li>
                            {showCostCenterInTimesheetBy.toLowerCase() == "Employee".toLowerCase() ? (
                                <li className='nav-item'>
                                    <a
                                        className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'CostCenterList' })}
                                        onClick={() => setTab('CostCenterList')}
                                        role='tab'
                                    >
                                        {/* {t("Cost Center")} */}
                                        {getValueFromResource('Cost Center',dispatch, t)}

                                    </a>
                                </li>
                            ) : null}

                        </ul>
                        <div className='tab-content pt-0'>
                            {childs.IsProject && <div className={clsx('tab-pane', { active: tab === 'ProjectList' })}>
                                {tab === 'ProjectList' &&
                                    <EmployeeProjectList IsProjectEdit={childs.IsProjectEdit} AccountEmployeeId={AccountEmployeeId} />
                                }
                            </div>}
                            {childs.IsTask && <div className={clsx('tab-pane', { active: tab === 'TaskList' })}>
                                {tab === 'TaskList' &&
                                    <EmployeeTaskList AccountEmployeeId={AccountEmployeeId} />
                                }
                            </div>}
                            {childs.IsTimeOff && <div className={clsx('tab-pane', { active: tab === 'TimeOffList' })}>
                                {tab === 'TimeOffList' &&
                                    <EmployeeTimeOffList IsTimeOffEdit={childs.IsTimeOffEdit} AccountEmployeeId={AccountEmployeeId} employeeNameWithCode={employeeSummary.employeeNameWithCode} />
                                }
                            </div>}
                            <div className={clsx('tab-pane', { active: tab === 'EmailPreferenceList' })}>
                                {tab === 'EmailPreferenceList' &&

                                    <EmployeeEmailNotificationPreferences AccountEmployeeId={AccountEmployeeId} />
                                }
                            </div>
                            {(showCostCenterInTimesheetBy.toLowerCase() == "Employee".toLowerCase()) ?
                                (
                                    <div className={clsx('tab-pane', { active: tab === 'CostCenterList' })}>
                                        {tab === 'CostCenterList' &&

                                            <EmployeeCostCenter AccountEmployeeId={AccountEmployeeId} />
                                        }
                                    </div>
                                ) : null
                            }
                        </div>
                    </div>
                    <div className='col-md-3'>
                        <div className="d-flex align-items-center mt-3 mb-3">
                            <a className="text-muted fs-6 fw-bold me-2">
                                {/* {t('Timesheet Summary')} */}
                                {getValueFromResource('Summary',dispatch, t)}

                                </a>
                        </div>
                        <div className='col-md-12 col-sm-12 col-xs-12'>
                            <div className='cardInfoShadow' style={{ height: 132 }}>
                                <div className='tsNavBarInnerBoxParent'>
                                    <div className='tsNavBarInnerBoxSecondSection' style={{ left: 8, top: 10 }}>
                                        <span className="fw-bold d-block fs-3 tsNavBarInfoText">
                                            {employeeSummary.totalHours}</span>
                                        <a className="text-uppercase tsNavBarInfoLabel">
                                            {/* {t('Total Hours')} */}
                                            {getValueFromResource('Total Hours',dispatch, t)}

                                            </a>
                                    </div>
                                </div>
                                <div className='row mt-10'>
                                    <div className='col-md-6'>
                                        <span className="fw-bold d-block fs-3 tsNavBarInfoText" style={{ marginLeft: 8 }}>
                                            {employeeSummary.billableHours}
                                            </span>
                                    </div>

                                    <div className='col-md-6'>
                                        <span className="fw-bold d-block fs-3 tsNavBarInfoText">{employeeSummary.nonBillableHours}</span>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <span className="text-uppercase tsNavBarInfoLabel" style={{ marginLeft: 8 }}>
                                            {/* {t('Billable Hours')} */}
                                            {getValueFromResource('Billable Hours',dispatch, t)}

                                            </span>
                                    </div>
                                    <div className='col-md-6'>
                                        <span className="text-uppercase tsNavBarInfoLabel">
                                            {/* {t('Non Billable Hours')} */}
                                            {getValueFromResource('Non Billable Hours',dispatch, t)}

                                            </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EmployeeOffCanvas
                obj={generalObject}
            />
        </>

    )
}